import React from 'react';

const KeyboardArrowInsert = ({ width = 24, height = 24, fill = '#666666', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.71252 14.8875V7.2875C7.71252 7.00416 7.61669 6.76666 7.42502 6.575C7.23336 6.38333 6.99586 6.2875 6.71252 6.2875C6.42919 6.2875 6.19169 6.38333 6.00002 6.575C5.80836 6.76666 5.71252 7.00416 5.71252 7.2875V17.2875C5.71252 17.5708 5.80836 17.8083 6.00002 18C6.19169 18.1917 6.42919 18.2875 6.71252 18.2875H16.7125C16.9959 18.2875 17.2334 18.1917 17.425 18C17.6167 17.8083 17.7125 17.5708 17.7125 17.2875C17.7125 17.0042 17.6167 16.7667 17.425 16.575C17.2334 16.3833 16.9959 16.2875 16.7125 16.2875H9.11252L18.0125 7.3875C18.1959 7.20416 18.2875 6.97083 18.2875 6.6875C18.2875 6.40416 18.1959 6.17083 18.0125 5.9875C17.8292 5.80416 17.5959 5.7125 17.3125 5.7125C17.0292 5.7125 16.7959 5.80416 16.6125 5.9875L7.71252 14.8875Z" fill={fill}/>
  </svg>
);

export default KeyboardArrowInsert;
